<template>
  <div>
    <button
      type="button"
      class="btn btnclass smallerfontsize mr-3 selected"
      @click="form.showDateSiteModal = true"
    >
      Datum
    </button>
  
    <b-modal
      id="modal-date"
      v-model="form.showDateSiteModal"
      title="Datum"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveDate"
    >
      <b-row class="my-3 px-3">
        <b-col
          class="mb-2"
          lg="6"
        >
          <label for="date-from-datepicker">Konsumtion från *</label>
          <date-picker
            id="date-from-datepicker"
            ref="datepickerStartdate"
            v-model="dateData.tempStartDate"
            :months="form.datePicker.months"
            :weekdays="form.datePicker.weekdays"         
            :show-week-number="true"
            class="datepicker"
            value-type="format"
            :disabled-date="isFromDateDisabled"
            :clearable="false"
          />
          <b-form-invalid-feedback id="dateFrom-input-feedback">
            Fyll i fältet
          </b-form-invalid-feedback>
        </b-col>

        <!-- Pub. Datum till * - input -->
        <b-col
          class="mb-2"
          lg="6"
        >
          <label for="date-to-datepicker">Konsumtion till *</label>
          <date-picker
            id="date-to-datepicker"
            v-model="dateData.tempEndDate"
            :months="form.datePicker.months"
            :weekdays="form.datePicker.weekdays"      
            :show-week-number="true"
            class="datepicker"
            value-type="format"
            :disabled-date="isEndDateDisabled"
            :clearable="false"
          />
          <b-form-invalid-feedback id="dateTo-input-feedback">
            Fyll i fältet
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import {
  isDateNotBetweenTwoDates
} from "@/assets/js/utils.js"

  export default {
    name: 'DateSiteModal',
    components: {
        DatePicker,
    },
    props: {
      form: {
        type: Object,
        required: true,
      }
    },
  data() {
    return {
        dateData:{
          tempStartDate: "",
          tempEndDate: "",
        }
      }
    },
    watch: {
      "dateData.tempStartDate"(startDate) {
          if (startDate > this.dateData.tempEndDate)
            this.dateData.tempEndDate = startDate;
      },
      "dateData.tempEndDate"(endDate) {
          if (this.dateData.tempStartDate > endDate)
            this.dateData.tempStartDate = endDate;
      }
    },
    methods: {
      popupIsShown(){
        document.addEventListener("keyup", this.onKeyUp);
        let apiBody = this.$store.state.siteApiBody.payload;
        this.dateData.tempStartDate = apiBody.consumption_start_date
        this.dateData.tempEndDate = apiBody.consumption_end_date
        setTimeout(() => {
        this.$refs.datepickerStartdate.focus();
      }, "100");
      },
      isFromDateDisabled(date) {
        let disableDate = isDateNotBetweenTwoDates(
          date,
          new Date(this.$store.state.systemInfo.publishedFromDate),
          new Date(this.$store.state.systemInfo.publishedToDate),
        );
        return disableDate;
      },
      isEndDateDisabled(date) {
        let disableDate = isDateNotBetweenTwoDates(
          date,
          new Date(this.$store.state.systemInfo.publishedFromDate),
          new Date(this.$store.state.systemInfo.publishedToDate),
        );
        return disableDate;
      },
      saveDate(){
        let payload = this.$store.getters['siteApiBody/getPayload']
        payload.consumption_start_date = this.dateData.tempStartDate
        payload.consumption_end_date = this.dateData.tempEndDate
        this.$store.commit(
          'siteApiBody/updatePayload',
          payload,
        );
      },
      popupIsHidden(){
        document.removeEventListener("keyup", this.onKeyUp);
      },
      onKeyUp(event) {
        if (event.key === "Enter" && this.form.showDateSiteModal) {
          this.form.showDateSiteModal = false;
          this.saveDate()
        }
      },
    }
}
</script>